import React from 'react';
import { WLItem } from 'src/components/Wishlists/WishlistItem';
import { Button, Modal, Picker } from '@riac/design-system';
import { Item } from '@react-stately/collections';
import { IWishlist, IWishlistItem } from 'src/lib/WishlistTypes.i';

export const ShowWishlist = ({
  currentListId,
  auctionWishlists,
  setCurrentListId,
  itemList,
  setItemList,
  closeModal,
  auctionTitle,
}):JSX.Element => {
  console.log(auctionWishlists);
  return (
    <Modal
      isOpen
      onClose={() => closeModal()}
      showCloseButton
      isDismissable
      title={auctionTitle}
      type='narrow'
      fullHeight
      footerButtons={<>
        <Button onPress={closeModal}>Close</Button>
      </>}
    >
      <h4>Wishlists</h4>
      <Picker
        label = 'Select Wishlist to View'
        selectedKey = {currentListId.toString()}
        onSelectionChange = {(value:string) => {
          setCurrentListId(value);
        }}
      >
        {auctionWishlists?.map((wl:IWishlist) => (
          <Item key = {wl.WishListID.toString()}>
            {wl.WishListName}
          </Item>
        ))}
      </Picker>
      <div className='flex flex-col gap-5'>
        {itemList.map((item:IWishlistItem) => (
          <WLItem
            wishlistId={currentListId}
            item={item}
            key={item.AuctionItemID}
            removeFromList={(wlId) =>
              setItemList((list:IWishlistItem[]) => list.filter((item:IWishlistItem) => item.WishListItemID !== wlId))
            }
          />
        ))}
      </div>
    </Modal>
  );
};
